(() => {
  const placeholderText = new Set([
    'Powermeter', 'XXE', 'SIGEYI', 'Wheels', 'Fitelite', 'Crank',
    'Accessories', 'Customize Cycling Tour Plan', 'Customize Your Own Bike'
  ]);
  const trustLinks = [
    ['Quote process', '/pages/how-quote-requests-work'],
    ['Shipping', '/pages/shipping-delivery'],
    ['Returns & warranty', '/pages/returns-warranty'],
    ['About', '/pages/about-velo-atlas']
  ];
  const disclaimerText = 'Velo Atlas is an independent sourcing service. Brand names, logos, and trademarks are used only to identify compatible or requested products. Velo Atlas is not affiliated with, sponsored by, or endorsed by these brands unless expressly stated.';
  const hasQuoteSuccess = /(?:^|&)contact_posted=true(?:&|$)/.test(window.location.search.slice(1));
  let quoteSuccessFocused = false;

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const priceUiPattern = /^(price|价格)$|price, low to high|price, high to low|sort by price|按价格/i;
  const sameStorePath = (href) => {
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin ? url.pathname : '';
    } catch (error) {
      return '';
    }
  };
  const hide = (el) => {
    if (!el) return;
    el.classList?.add('va-hidden-price-ui');
    el.setAttribute?.('hidden', 'hidden');
    if (el.style) el.style.display = 'none';
  };
  const closestPriceBlock = (node) => node?.closest('details, fieldset, form, .facets__disclosure, .facets__item, .facets__price, .filter, .filter-group, .accordion, li, option, select, div');

  function quotePanel() {
    return document.querySelector('#request-quote');
  }

  function createNotice(className, title, body) {
    const notice = document.createElement('div');
    notice.className = className;
    notice.setAttribute('role', className.includes('success') ? 'status' : 'note');
    notice.innerHTML = `<strong>${title}</strong><span>${body}</span>`;
    return notice;
  }

  function addQuoteConfidence() {
    const panel = quotePanel();
    if (!panel) return;
    if (!panel.querySelector('.va-quote-confidence')) {
      const note = createNotice(
        'va-quote-confidence',
        'Live quote with full landed-cost follow-up.',
        'Frame costs move with warehouse availability, freight, duties/taxes, and currency. Send the form and we will confirm current product price, shipping, import costs where applicable, and ETA by email within 1-2 business days.'
      );
      const form = panel.querySelector('form');
      if (form) form.insertAdjacentElement('beforebegin', note);
      else panel.prepend(note);
    }
    if (!panel.querySelector('.va-sourcing-disclaimer')) {
      const disclaimer = document.createElement('p');
      disclaimer.className = 'va-sourcing-disclaimer';
      disclaimer.textContent = disclaimerText;
      const form = panel.querySelector('form');
      if (form) form.insertAdjacentElement('afterend', disclaimer);
      else panel.appendChild(disclaimer);
    }
  }

  function showQuoteSuccess() {
    if (!hasQuoteSuccess) return;
    const panel = quotePanel() || document.querySelector('main');
    if (!panel || panel.querySelector('.va-quote-success')) return;
    const notice = createNotice(
      'va-quote-success',
      'Quote request sent.',
      'Thank you. We received your request and will reply by email within 1-2 business days with current availability, product price, shipping, and import duties/taxes where applicable.'
    );
    notice.setAttribute('tabindex', '-1');
    panel.prepend(notice);
    if (!quoteSuccessFocused) {
      quoteSuccessFocused = true;
      window.setTimeout(() => {
        notice.focus({ preventScroll: true });
        notice.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 250);
    }
  }

  function trackQuoteSubmit() {
    const panel = quotePanel();
    if (!panel) return;
    panel.querySelectorAll('form').forEach((form) => {
      if (form.dataset.vaQuoteTracked) return;
      form.dataset.vaQuoteTracked = 'true';
      form.addEventListener('submit', () => {
        if (panel.querySelector('.va-quote-pending')) return;
        const pending = createNotice(
          'va-quote-pending',
          'Sending your quote request...',
          'Please wait a moment. A confirmation message will appear after Shopify accepts the request.'
        );
        form.insertAdjacentElement('beforebegin', pending);
      });
    });
  }

  function ensureHomeMotionStyles() {
    if (document.getElementById('va-home-motion-styles')) return;
    const style = document.createElement('style');
    style.id = 'va-home-motion-styles';
    style.textContent = `
      .va-home-hero-section{position:relative;isolation:isolate;overflow:hidden;min-height:clamp(460px,56vw,660px);display:flex;align-items:center;background-position:center!important;background-size:cover!important}
      .va-home-hero-section:before{content:"";position:absolute;inset:0;z-index:1;background:linear-gradient(90deg,rgba(2,6,23,.76) 0%,rgba(15,23,42,.56) 42%,rgba(15,23,42,.22) 72%,rgba(2,6,23,.44) 100%),linear-gradient(180deg,rgba(2,6,23,.28),rgba(2,6,23,.52));pointer-events:none}
      .va-home-hero-section>*:not(.va-hero-motion){position:relative;z-index:2}.va-home-hero-panel{max-width:min(880px,calc(100vw - 36px));padding:clamp(48px,8vw,92px) clamp(18px,5vw,72px);color:#fff;text-shadow:0 2px 18px rgba(0,0,0,.38)}
      .va-home-hero-title{max-width:820px;margin:0!important;font-size:clamp(2.55rem,6.4vw,6.8rem)!important;line-height:.93!important;letter-spacing:0!important;color:#fff!important}.va-home-subcopy{display:block;margin-top:18px;max-width:760px;font-size:clamp(1rem,1.45vw,1.28rem);line-height:1.48;color:rgba(255,255,255,.9)!important}
      .va-home-hero-actions{display:flex;gap:12px;flex-wrap:wrap;margin-top:26px}.va-home-hero-actions a{display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:0 18px;border:1px solid rgba(255,255,255,.35);border-radius:4px;text-decoration:none!important;font-weight:700;letter-spacing:0;color:#fff!important;backdrop-filter:blur(8px)}
      .va-home-hero-primary{background:#ffffff!important;color:#111827!important;border-color:#fff!important;text-shadow:none}.va-home-hero-secondary{background:rgba(15,23,42,.28)!important}.va-home-hero-trust{display:flex;gap:10px;flex-wrap:wrap;margin-top:18px;padding:0;list-style:none}.va-home-hero-trust li{padding:7px 10px;border:1px solid rgba(255,255,255,.24);border-radius:999px;background:rgba(2,6,23,.22);font-size:.82rem;color:rgba(255,255,255,.88)}
      .va-hero-motion{position:absolute;inset:0;z-index:1;overflow:hidden;pointer-events:none;opacity:.92}.va-hero-motion-road{position:absolute;left:42%;right:-12%;bottom:-12%;height:54%;transform:skewX(-18deg) rotate(-2deg);background:linear-gradient(90deg,transparent,rgba(255,255,255,.18),transparent);filter:blur(1px);animation:va-road-drift 6.8s linear infinite}.va-hero-motion-road:before,.va-hero-motion-road:after{content:"";position:absolute;inset:auto 0 30% 0;height:2px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.42),transparent);animation:va-line-pulse 3.8s ease-in-out infinite}.va-hero-motion-road:after{bottom:54%;animation-delay:1.2s;opacity:.72}
      .va-hero-motion-grid{position:absolute;inset:-30% -10% -10% 48%;background-image:linear-gradient(rgba(255,255,255,.11) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.08) 1px,transparent 1px);background-size:72px 72px;transform:perspective(520px) rotateX(62deg) rotateZ(-10deg);transform-origin:center bottom;animation:va-grid-flow 9s linear infinite;opacity:.38}.va-hero-motion-scan{position:absolute;inset:0;background:linear-gradient(105deg,transparent 0%,transparent 38%,rgba(255,255,255,.18) 45%,rgba(125,211,252,.24) 48%,transparent 56%,transparent 100%);transform:translateX(-80%);animation:va-scan 7.5s ease-in-out infinite;mix-blend-mode:screen}
      .va-hero-motion-frame{position:absolute;right:7%;top:20%;width:min(36vw,520px);height:min(22vw,300px);opacity:.48;filter:drop-shadow(0 0 18px rgba(147,197,253,.35));animation:va-frame-glow 4.5s ease-in-out infinite}.va-hero-motion-frame span{position:absolute;height:2px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.72),transparent);transform-origin:left center}.va-hero-motion-frame span:nth-child(1){left:10%;top:58%;width:62%;transform:rotate(-16deg)}.va-hero-motion-frame span:nth-child(2){left:29%;top:26%;width:42%;transform:rotate(31deg)}.va-hero-motion-frame span:nth-child(3){left:47%;top:34%;width:34%;transform:rotate(70deg)}.va-hero-motion-frame span:nth-child(4){left:14%;top:75%;width:52%;transform:rotate(-1deg)}.va-hero-motion-frame span:nth-child(5){left:70%;top:48%;width:24%;transform:rotate(-28deg)}
      @keyframes va-road-drift{0%{transform:translate3d(8%,4%,0) skewX(-18deg) rotate(-2deg);opacity:.35}50%{opacity:.82}100%{transform:translate3d(-18%,-5%,0) skewX(-18deg) rotate(-2deg);opacity:.35}}@keyframes va-line-pulse{0%,100%{opacity:.18;transform:translateX(18%)}50%{opacity:.9;transform:translateX(-10%)}}@keyframes va-grid-flow{0%{background-position:0 0}100%{background-position:0 144px}}@keyframes va-scan{0%,22%{transform:translateX(-86%);opacity:0}36%,64%{opacity:.72}82%,100%{transform:translateX(86%);opacity:0}}@keyframes va-frame-glow{0%,100%{opacity:.28;transform:translateY(0)}50%{opacity:.58;transform:translateY(-8px)}}
      @media (max-width:749px){.va-home-hero-section{min-height:560px}.va-home-hero-panel{padding:72px 18px 54px}.va-home-hero-title{font-size:clamp(2.35rem,15vw,4.5rem)!important}.va-home-hero-actions a{width:100%}.va-hero-motion-frame{right:-18%;top:48%;width:82vw;height:44vw}.va-hero-motion-grid{left:18%;opacity:.25}.va-hero-motion-road{left:14%;height:44%;bottom:-4%}}
      @media (prefers-reduced-motion:reduce){.va-hero-motion *{animation:none!important}}
    `;
    document.head.appendChild(style);
  }

  function addHomeHeroMotion(section) {
    if (!section || section.querySelector('.va-hero-motion')) return;
    const motion = document.createElement('div');
    motion.className = 'va-hero-motion';
    motion.setAttribute('aria-hidden', 'true');
    motion.innerHTML = '<div class="va-hero-motion-road"></div><div class="va-hero-motion-grid"></div><div class="va-hero-motion-frame"><span></span><span></span><span></span><span></span><span></span></div><div class="va-hero-motion-scan"></div>';
    section.appendChild(motion);
  }

  function addHomeHeroActions(panel) {
    if (!panel || panel.querySelector('.va-home-hero-actions')) return;
    const actions = document.createElement('div');
    actions.className = 'va-home-hero-actions';
    actions.innerHTML = '<a class="va-home-hero-primary" href="/collections/road-framesets">Request a Live Quote</a><a class="va-home-hero-secondary" href="/collections/all">Browse Framesets</a>';
    panel.appendChild(actions);
  }

  function addHomeHeroTrust(panel) {
    if (!panel || panel.querySelector('.va-home-hero-trust')) return;
    const trust = document.createElement('ul');
    trust.className = 'va-home-hero-trust';
    trust.innerHTML = '<li>1-2 business day reply</li><li>Landed-cost quote</li><li>Independent sourcing service</li>';
    panel.appendChild(trust);
  }

  function polishNavigation() {
    document.querySelectorAll('a[href]').forEach((anchor) => {
      const label = clean(anchor.textContent || anchor.getAttribute('aria-label'));
      const path = sameStorePath(anchor.getAttribute('href'));
      if (label === 'Frameset' && path === '/') anchor.setAttribute('href', '/collections/road-framesets');
      if (label === 'Components' && path === '/collections') anchor.setAttribute('href', '/collections/accessories-small-parts');
      if (placeholderText.has(label) && path === '/') {
        anchor.classList.add('va-hidden-placeholder-nav');
        const item = anchor.closest('li');
        if (item) item.classList.add('va-hidden-placeholder-nav');
      }
    });
  }

  function hideCartEntrances() {
    document.querySelectorAll("a[href*='/cart'], button[name='checkout'], cart-icon, .cart-count-bubble").forEach((el) => {
      el.classList.add('va-hidden-cart-ui');
    });
  }

  function rewriteQuoteAccountLinks() {
    const panel = quotePanel();
    if (!panel) return;
    const returnUrl = `${window.location.pathname}${window.location.search}#request-quote`;
    panel.querySelectorAll('a').forEach((anchor) => {
      const label = clean(anchor.textContent).toLowerCase();
      if (!label.includes('sign in') && !label.includes('create account')) return;
      const target = label.includes('create') ? '/account/register' : '/account/login';
      const desired = `${target}?return_url=${encodeURIComponent(returnUrl)}`;
      if (anchor.getAttribute('href') !== desired) anchor.setAttribute('href', desired);
    });
  }

  function scrubPriceControls() {
    document.querySelectorAll('select option, option').forEach((option) => {
      const value = `${option.value} ${option.textContent}`;
      if (priceUiPattern.test(clean(value)) || /price/i.test(value)) {
        option.disabled = true;
        option.hidden = true;
        option.remove();
      }
    });
    document.querySelectorAll('select').forEach((select) => {
      Array.from(select.options).forEach((option) => {
        const value = `${option.value} ${option.textContent}`;
        if (priceUiPattern.test(clean(value)) || /price/i.test(value)) option.remove();
      });
      const selected = select.options[select.selectedIndex];
      if (selected && /price|价格/i.test(`${selected.value} ${selected.textContent}`)) select.selectedIndex = 0;
    });
    document.querySelectorAll('input[name*="price"], input[id*="Price"], input[id*="price"], input[name*="filter.v.price"]').forEach((input) => {
      hide(input.closest('details, fieldset, form, .facets__price, .facets__disclosure, .filter-group') || closestPriceBlock(input));
    });
    document.querySelectorAll('summary, button, label, span').forEach((node) => {
      if (priceUiPattern.test(clean(node.textContent))) {
        hide(node.closest('details, fieldset, .facets__disclosure, .filter-group, li, div') || node);
      }
    });
  }

  function polishHome() {
    const main = document.querySelector('main[data-template]');
    const isHome = window.location.pathname === '/' || (main && /^index/.test(main.dataset.template || ''));
    if (!isHome) return;
    ensureHomeMotionStyles();

    document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach((heading) => {
      const label = clean(heading.textContent);
      if (label === 'Ride Beyond Limits' || label === 'Velo Atlas Quote Desk' || label === 'Premium Road Framesets, Quoted Live') {
        const section = heading.closest('.shopify-section, section') || heading.parentElement;
        const panel = heading.parentElement || section;
        if (section) {
          section.classList.add('va-home-hero-section');
          addHomeHeroMotion(section);
        }
        if (panel) panel.classList.add('va-home-hero-panel');
        heading.classList.add('va-home-hero-title');
        heading.textContent = 'Premium Road Framesets, Quoted Live';
        let subcopy = panel?.querySelector('.va-home-subcopy');
        if (!subcopy) {
          subcopy = document.createElement('span');
          subcopy.className = 'va-home-subcopy';
          heading.insertAdjacentElement('afterend', subcopy);
        }
        subcopy.textContent = 'Cervelo, Colnago, Pinarello, Specialized, Officine Mattio and more. Current availability, shipping, duties and taxes confirmed by email.';
        addHomeHeroActions(panel);
        addHomeHeroTrust(panel);
      }
      if (label === 'Discounted Framesets') {
        const section = heading.closest('.shopify-section, section');
        if (section) section.classList.add('va-hidden-placeholder-nav');
      }
      if (label === 'Our Services') heading.textContent = 'Quote-first sourcing';
      if (label === 'Shipping') heading.textContent = 'Shipping confirmed by quote';
      if (label === 'Discover The World With Your Bike') heading.textContent = 'Build planning by email';
    });
    document.querySelectorAll('p').forEach((paragraph) => {
      const label = clean(paragraph.textContent);
      if (label === 'Join our cycling tours now!') {
        paragraph.textContent = 'Tell us the frame, size, destination, and build details. We confirm current availability before you commit.';
      }
    });
    document.querySelectorAll('a,button').forEach((el) => {
      if (clean(el.textContent) === 'Discover Now') el.textContent = 'View products';
      if (clean(el.textContent) === 'Discover More') el.textContent = 'Request advice';
    });
  }

  function addFooterTrustLinks() {
    const footer = document.querySelector('footer');
    if (!footer) return;
    if (!footer.querySelector('.va-footer-trust-links')) {
      const nav = document.createElement('nav');
      nav.className = 'va-footer-trust-links';
      nav.setAttribute('aria-label', 'Velo Atlas information pages');
      trustLinks.forEach(([label, href]) => {
        const a = document.createElement('a');
        a.textContent = label;
        a.href = href;
        nav.appendChild(a);
      });
      footer.appendChild(nav);
    }
    if (!footer.querySelector('.va-footer-sourcing-disclaimer')) {
      const disclaimer = document.createElement('p');
      disclaimer.className = 'va-footer-sourcing-disclaimer';
      disclaimer.textContent = disclaimerText;
      footer.appendChild(disclaimer);
    }
  }

  let queued = false;
  function run() {
    document.documentElement.classList.add('va-polish-ready');
    polishNavigation();
    hideCartEntrances();
    rewriteQuoteAccountLinks();
    addQuoteConfidence();
    showQuoteSuccess();
    trackQuoteSubmit();
    scrubPriceControls();
    polishHome();
    addFooterTrustLinks();
  }
  function queueRun() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('load', run, { once: true });
  [500, 1000, 2000, 4000, 8000, 12000].forEach((delay) => window.setTimeout(run, delay));
  new MutationObserver(queueRun).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'class', 'style'] });
})();

/* VA_HOMEPAGE_IMAGE_HERO_START */
(() => {
  const heroImage = 'https://cdn.shopify.com/s/files/1/0742/9174/0762/files/velo-atlas-premium-road-framesets-homepage-hero.png?v=1786252256';
  const target = '/collections/road-framesets';

  function ensureImageHeroStyles() {
    if (document.getElementById('va-homepage-image-hero-styles')) return;
    const style = document.createElement('style');
    style.id = 'va-homepage-image-hero-styles';
    style.textContent = `
      .va-home-hero-section.va-image-hero{
        position:relative!important;
        isolation:isolate;
        overflow:hidden;
        background-color:#050505!important;
        background-image:var(--va-home-hero-image)!important;
        background-repeat:no-repeat!important;
      }
      .va-image-hero .va-hero-motion{display:none!important}
      .va-image-hero-hotspot{
        position:absolute!important;
        z-index:30!important;
        display:block;
        color:transparent!important;
        background:transparent;
        border:1px solid transparent;
        border-radius:2px;
        text-decoration:none!important;
        cursor:pointer;
      }
      .va-image-hero-hotspot:focus-visible{
        outline:3px solid #e9b36f;
        outline-offset:4px;
        background:rgba(233,179,111,.08);
      }
      @media (min-width:750px){
        .va-home-hero-section.va-image-hero{
          min-height:0!important;
          height:auto!important;
          aspect-ratio:1672/941;
          align-items:stretch!important;
          background-size:100% 100%!important;
          background-position:center!important;
        }
        .va-home-hero-section.va-image-hero:before{display:none!important}
        .va-image-hero>*:not(.va-image-hero-hotspot){
          visibility:hidden!important;
          opacity:0!important;
          pointer-events:none!important;
        }
        .va-image-hero-hotspot{
          left:7.12%;
          top:69.08%;
          width:20.63%;
          height:7.23%;
        }
        .va-image-hero-hotspot:hover{
          border-color:rgba(239,185,115,.62);
          background:rgba(239,185,115,.06);
          box-shadow:0 0 28px rgba(239,185,115,.12);
        }
      }
      @media (max-width:749px){
        .va-home-hero-section.va-image-hero{
          min-height:clamp(580px,160vw,680px)!important;
          aspect-ratio:auto!important;
          align-items:center!important;
          background-size:cover!important;
          background-position:67% center!important;
        }
        .va-home-hero-section.va-image-hero:before{
          display:block!important;
          background:linear-gradient(90deg,rgba(2,3,5,.94) 0%,rgba(2,3,5,.80) 48%,rgba(2,3,5,.20) 100%)!important;
        }
        .va-image-hero .va-home-hero-panel{
          visibility:visible!important;
          opacity:1!important;
          pointer-events:auto!important;
          width:100%!important;
          max-width:100%!important;
          padding:58px 20px 42px!important;
          color:#f5f0e9!important;
        }
        .va-image-hero .va-home-hero-title{
          max-width:330px!important;
          margin:0!important;
          font-size:clamp(2.65rem,13vw,4.3rem)!important;
          line-height:.96!important;
          color:#f5f0e9!important;
          text-shadow:0 3px 24px rgba(0,0,0,.7)!important;
        }
        .va-image-hero .va-home-subcopy{
          max-width:315px!important;
          margin-top:22px!important;
          font-size:1rem!important;
          line-height:1.55!important;
          color:rgba(245,240,233,.84)!important;
        }
        .va-image-hero .va-home-hero-actions{margin-top:26px!important}
        .va-image-hero .va-home-hero-primary{display:none!important}
        .va-image-hero .va-home-hero-secondary{
          display:inline-flex!important;
          width:min(100%,345px)!important;
          min-height:56px!important;
          justify-content:center!important;
          border:1px solid #d6a565!important;
          border-radius:0!important;
          background:rgba(3,4,5,.70)!important;
          color:#e8b777!important;
          backdrop-filter:blur(8px);
        }
        .va-image-hero .va-home-hero-trust{
          display:grid!important;
          grid-template-columns:1fr!important;
          gap:8px!important;
          max-width:270px!important;
          margin-top:20px!important;
        }
        .va-image-hero .va-home-hero-trust li{
          border-color:rgba(214,165,101,.42)!important;
          border-radius:6px!important;
          background:rgba(3,4,5,.56)!important;
          color:rgba(245,240,233,.90)!important;
        }
        .va-image-hero-hotspot{display:none!important}
      }
      @media (prefers-reduced-motion:reduce){
        .va-image-hero-hotspot{transition:none!important}
      }
    `;
    document.head.appendChild(style);
  }

  function applyImageHero() {
    const main = document.querySelector('main[data-template]');
    const isHome = window.location.pathname === '/' || (main && /^index/.test(main.dataset.template || ''));
    if (!isHome) return;

    ensureImageHeroStyles();
    const section = document.querySelector('.va-home-hero-section') ||
      Array.from(document.querySelectorAll('.shopify-section, section')).find((candidate) =>
        candidate.querySelector('h1,h2,h3,h4,h5,h6')
      );
    if (!section) return;

    section.classList.add('va-home-hero-section', 'va-image-hero');
    section.style.setProperty('--va-home-hero-image', `url("${heroImage}")`);
    section.setAttribute('aria-label', 'Premium road framesets with live landed-cost quotes');

    const heading = section.querySelector('.va-home-hero-title, h1, h2, h3, h4, h5, h6');
    if (heading) heading.textContent = 'Premium Road Framesets';

    const panel = section.querySelector('.va-home-hero-panel') || heading?.parentElement;
    if (panel) {
      panel.classList.add('va-home-hero-panel');
      const subcopy = panel.querySelector('.va-home-subcopy');
      if (subcopy) {
        subcopy.textContent = 'Live landed-cost quotes for Cervelo, Colnago, Pinarello, Specialized, Officine Mattio and more.';
      }
      const actions = panel.querySelector('.va-home-hero-actions');
      if (actions) {
        const browse = actions.querySelector('.va-home-hero-secondary') || actions.querySelector('a');
        if (browse) {
          browse.href = target;
          browse.textContent = 'Browse Framesets';
        }
      }
    }

    let hotspot = section.querySelector('.va-image-hero-hotspot');
    if (!hotspot) {
      hotspot = document.createElement('a');
      hotspot.className = 'va-image-hero-hotspot';
      hotspot.href = target;
      hotspot.setAttribute('aria-label', 'Browse Framesets');
      hotspot.title = 'Browse Framesets';
      hotspot.textContent = 'Browse Framesets';
      section.appendChild(hotspot);
    }
  }

  const schedule = () => window.requestAnimationFrame(applyImageHero);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
/* VA_HOMEPAGE_IMAGE_HERO_END */
